export const CrossBoxIcon = ({ ...props }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.667 0H2.333A2.333 2.333 0 0 0 0 2.333v9.334A2.333 2.333 0 0 0 2.333 14h9.334A2.333 2.333 0 0 0 14 11.667V2.333A2.333 2.333 0 0 0 11.667 0ZM2.333 11.667V2.333h9.334v9.334H2.333Z"
        fill="#AF0D04"
      />
      <path
        d="M9.746 4.254a.583.583 0 0 0-.826 0L7 6.175 5.08 4.254a.584.584 0 0 0-.827.826L6.175 7 4.253 8.92a.584.584 0 0 0 .826.826L7 7.825l1.92 1.921a.584.584 0 1 0 .827-.826L7.824 7l1.922-1.92a.583.583 0 0 0 0-.826Z"
        fill="#AF0D04"
      />
    </svg>
  );
};
